import { Pipe, PipeTransform } from '@angular/core';

import { SharedLanguageService } from '@language';
import { TranslateOrDefault } from '../../helpers/translate-or-default.helper';

@Pipe({
    standalone: false,
    name: 'translateOrDefault',
    pure: true
})
export class TranslateOrDefaultPipe implements PipeTransform {
    constructor(private readonly translateService: SharedLanguageService) {}

    transform(query: string, defaultValue?: string, ...args: string[]): any {
        return TranslateOrDefault(this.translateService, query, defaultValue, ...args);
    }
}
